export default __webpack_public_path__ + "static/media/Head_3_Ear_2_C2.9aa6e4ee.svg";